export default "__VITE_ASSET__DwWwDWF___"